export const getFeatureFlagOptions = (definition, defaultValue) => [
  { value: "__DEFAULT__", label: `Default (${defaultValue})` },
  ...definition.options
]
